import { canv } from "@/canv/global";
import type { textWidget } from "@/elements/text/text";
import { TextWidgetV2 } from "@/elements/text/textV2";

export type ShapeTextPart = textWidget | TextWidgetV2;

export class Shape {
    width = 200;
    height = 200;

    mode = "rect";

    needStroke = true; // - при создании фигуры линии будут отрисовываны
    needFill = true; // - при создании фигуры фон будет установлен

    defaultBorderDashType = "solid";
    defaultBorderWidth = this.width * 0.03;
    defaultColor = "transparent";
    includeText = true;

    // настройки для контекстного меню
    borderStyleEnabled = true; // флаг доступа настройки смены стиля(solid, dashed etc) линии фигуры
    borderWidthEnabled = true; // флаг доступа настройки смены ширины контура фигуры
    borderColorEnabled = true; // флаг доступа настройки смены цвета контура фигуры
    fillStyleEnabled = true; // флаг доступа настройки закрашивания фигуры

    setDrawStyle({
        color,
        borderColor,
        borderDashType,
        borderWidth,
    }: {
        color: string;
        borderColor: string;
        borderDashType: string;
        borderWidth: number;
    }) {
        this.setFillStrokeStyle(color);
        this.setStrokeType(borderColor, borderDashType, borderWidth);
    }

    setFillStrokeStyle(color: string) {
        if (color !== "transparent") {
            canv.ctx.fillStyle = color;
            canv.ctx.strokeStyle = color;
            canv.ctx.lineWidth = 4;
            canv.ctx.fill();
        }
    }

    setStrokeType(borderColor: string, borderDashType: string, borderWidth: number) {
        if (borderColor !== "transparent") {
            canv.ctx.strokeStyle = borderColor;
            if (borderDashType === "solid") {
                canv.ctx.setLineDash([]);
            } else if (borderDashType === "dashed") {
                canv.ctx.setLineDash([5 * borderWidth, 2 * 5 * borderWidth]);
            } else if (borderDashType === "dotted") {
                canv.ctx.lineCap = "round";
                canv.ctx.setLineDash([0.00001, 5 * borderWidth]);
            }
            canv.ctx.lineWidth = borderWidth;
            canv.ctx.stroke();
        }
    }

    protected getTextLineHeight(textPart: ShapeTextPart) {
        return textPart instanceof TextWidgetV2
            ? textPart.lineHeight
            : textPart.lines[0].textHeight;
    }

    protected updateTextDims(textPart: ShapeTextPart) {
        if (textPart instanceof TextWidgetV2 && textPart.getIsEditing()) {
            return;
        }

        textPart.updateDims();
    }
}
